import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {ModalReconfirmNumberService} from "../../../../services/ux/modal-reconfirm-number.service";

@Component({
    selector: "app-modal-operator-reconfirm-number",
    templateUrl: "./modal-operator-reconfirm-number.component.html",
    styleUrls: ["./modal-operator-reconfirm-number.component.css"]
})
export class ModalOperatorReconfirmNumberComponent implements OnInit {

    open = false;

    @Output() mobileNumberSubmitted: EventEmitter<string> = new EventEmitter<string>();
    // * One/Albtelecom
    @Input() operator: string;

    @ViewChild("mobileNumber") mobileNumber;

    constructor(private modalService: ModalReconfirmNumberService) {
    }

    ngOnInit() {
        // * Subscribe to modelState$ to open/close the modal
        this.modalService.modalState$.subscribe({
            next: (state: boolean) => {
                if (!state) {
                    this.mobileNumber.nativeElement.value = "";
                }
                this.open = state;
            }
        });
    }

    // TODO: Should do checks about amount
    submitMobileNumber(mobileNumber: string) {
        if (!mobileNumber) {
            this.mobileNumberSubmitted.emit(null);
            return;
        }

        this.mobileNumberSubmitted.emit(mobileNumber);
    }

    close() {
        this.modalService.close();
    }
}
